/**
 * This file serves as the directory for components
 * The purpose is to manage exported components in a unified way for easier categorization
 */
/**
 * Layout components
 */
import Footer from './Footer';
import { SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import DashboardCards from './DashboardCards';

export { AvatarDropdown, AvatarName, Footer, SelectLang, DashboardCards };
